export default __webpack_public_path__ + "static/media/qrCode.9c5bfbeb.svg";